import TrackerGrid from "@/components/TrackerGrid";

// Phase 18 (item 3) — Cake / F&B Tracker.
// Access: Sandeep Singh (f&b PO) + super_admin — enforced server-side at
// /api/analytics/fnb-tracker. The sidebar hides the link for others.
const COLS = [
  { key: "ref_code", label: "Ref Code", type: "text", width: 160 },
  { key: "type", label: "Type", type: "select",
    options: ["Cake", "Food & Beverages"] },
  { key: "requirement_date", label: "Requirement Date", type: "text", width: 120 },
  { key: "requirement_time", label: "Requirement Time", type: "text", width: 100 },
  { key: "requirement_location", label: "Requirement Location", type: "text" },
  { key: "applicant_name", label: "Applicant", type: "text" },
  { key: "status", label: "Workflow Status", type: "select",
    options: ["In Progress", "Approved", "Completed", "Rejected", "On Hold"] },
  { key: "current_stage", label: "Current Stage", type: "text" },
  { key: "submitted_at", label: "Submitted At", type: "text", width: 160 },
];

export default function FnBTrackerPage() {
  return (
    <TrackerGrid
      endpoint="/analytics/fnb-tracker"
      exportPath="/analytics/fnb-tracker/export.xlsx"
      heading="Cake / F&B Tracker"
      columns={COLS}
      dateRangeKey="requirement_date"
    />
  );
}
